import { FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { useCurrentFormik } from 'hooks/useCurrentFormikContext'
import { ConvoluteInput, GdprRule } from 'model'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useReadGdprRulesQuery } from 'views/AdminDsgvoView/AdminDsgvoView.generated'

export type ConvoluteRuleFormValues = ConvoluteInput
export const ConvoluteRuleForm: React.FC = () => {
  const { t } = useTranslation()
  const { data } = useReadGdprRulesQuery()
  const formikContext = useCurrentFormik()
  const initialValues = formikContext ? formikContext.initialValues : undefined
  const options =
    data &&
    data.gdprRules &&
    data.gdprRules
      .filter((rule) => {
        return !rule.inactive
      })
      .map((x: GdprRule) => ({
        key: x._id,
        text: x.ruleName,
      }))
      .sort((a, b) =>
        a.text.toLocaleLowerCase().localeCompare(b.text.toLocaleLowerCase())
      )

  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="activeRuleset._id"
          render={(fieldProps: FieldProps<any>) => (
            <FormikDropdown
              label={t(`field.ruleType.${initialValues.type}`)}
              options={options || []}
              {...fieldProps}
            />
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
